import type { OnInit } from '@angular/core';
import type { FormGroup } from '@angular/forms';
import type { ESize } from '@common/enums';
import type { CustomButtonEventPayload } from '@components/sp-custom-button';
import type { TestimonialButtonSettingsFormType } from '@web/widgets/testimonial/type/testimonial-widget.type';

import { ChangeDetectionStrategy, Component } from '@angular/core';

import { EButtonStyleType } from '@common/enums';
import { ButtonMode, SpCustomButtonModule } from '@components/sp-custom-button';
import { ERadioGroupType } from '@ui/sp-radio-group';
import { WebBaseControlTypedSettingsComponent } from '@web/widgets/common/abstract/web-base-control-typed-settings.component';
import { CommonElementsModule } from '@web/widgets/common/common-elements.module';
import { WebCustomButtonComponent } from '@web/shared/components/web-custom-button/web-custom-button.component';

@Component({
    selector: 'web-testimonial-button-settings',
    templateUrl: './testimonial-button-settings.component.html',
    styleUrls: ['./testimonial-button-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonElementsModule, SpCustomButtonModule, WebCustomButtonComponent],
})
export class TestimonialButtonSettingsComponent
    extends WebBaseControlTypedSettingsComponent<FormGroup<TestimonialButtonSettingsFormType>>
    implements OnInit
{
    public readonly EButtonStyleType = EButtonStyleType;
    public readonly ERadioGroupType = ERadioGroupType;
    public readonly ButtonMode = ButtonMode;

    public setSize(value: string): void {
        this.size.setValue(value as ESize);
    }

    public customButtonChangeHandler(changes: CustomButtonEventPayload): void {
        this.buttonBase.setValue(changes.base, { emitEvent: false });
        this.buttonHover.setValue(changes.hover);
    }

    public get styleType(): TestimonialButtonSettingsFormType['styleType'] {
        return this.itemForm.get('styleType') as TestimonialButtonSettingsFormType['styleType'];
    }

    public get label(): TestimonialButtonSettingsFormType['label'] {
        return this.itemForm.get('label') as TestimonialButtonSettingsFormType['label'];
    }

    public get buttonBase(): TestimonialButtonSettingsFormType['buttonBase'] {
        return this.itemForm.get('buttonBase') as TestimonialButtonSettingsFormType['buttonBase'];
    }

    public get buttonHover(): TestimonialButtonSettingsFormType['buttonHover'] {
        return this.itemForm.get('buttonHover') as TestimonialButtonSettingsFormType['buttonHover'];
    }

    public get size(): TestimonialButtonSettingsFormType['size'] {
        return this.itemForm.get('size') as TestimonialButtonSettingsFormType['size'];
    }
}
